import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";

import { useAppForm } from "../form-context";
import { skopaPlatformFormOptions } from "./shared";
import { platformSchema } from "@/schemas/skopa/platformSchema";
import { revalidateLogic } from "@tanstack/react-form";
import { Input } from "@/client/components/shad/input";
import { Separator } from "@/client/components/shad/separator";
import { PositionFields } from "../components/PositionFields";
import { PlatformBlock } from "./blocks/PlatformBlock";
import { PositionBlock } from "./blocks/PositionBlock";
import { SilosBlock } from "./blocks/SilosBlock";
import { Button } from "@/client/components/shad/button";

export const SkopaPlatformForm = () => {
  const form = useAppForm({
    ...skopaPlatformFormOptions,

    onSubmit: async ({ value }) => {
      console.log("Raw value", value);
    },
  });

  return (
    <form
      id="skopa-platform-form"
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <FieldGroup>
        <PlatformBlock form={form} />
        <Separator />
        <PositionBlock form={form} />

        <Separator />
        <SilosBlock form={form} />
        <Separator />

        <form.AppForm>
          <form.SubmitButton label="Log flight" />
        </form.AppForm>
      </FieldGroup>
    </form>
  );
};
